import {
    IUsuarioEquipeVendas,
    IUsuarioPorEquipeVendas,
} from "../../../../Interfaces/Vendas/EquipeVendas/UsuarioEquipeVendas/UsuarioEquipeVendas";
import Axios from "../../../Config/API";
import Service from "../../../Service";

//vincular
export async function VincularUsuarioEquipeVendasService(
    requestBody: IUsuarioEquipeVendas
) {
    return Service(
        Axios.post(
            `/vendas/equipevendas/vincularusuarioequipevenda`,
            requestBody
        )
    );
}

//desvincular
export async function DesvincularUsuarioEquipeVendasService(
    requestBody: IUsuarioEquipeVendas
) {
    return Service(
        Axios.put(
            `/vendas/equipevendas/desvincularusuarioequipevenda`,
            requestBody
        )
    );
}

//listar
export async function ListarUsuarioEquipeVendasService(idEquipeVendas: number) {
    return Service(
        Axios.get<Array<IUsuarioPorEquipeVendas>>(
            `/vendas/equipevendas/listarusuarioporequipevenda?idEquipeVendas=${idEquipeVendas}`
        )
    );
}
//listar Desvinculo

export async function ListarUsuarioEquipeVendaDesvinculadoService(
    idEquipeVendas: number
) {
    return Service(
        Axios.get<Array<IUsuarioPorEquipeVendas>>(
            `/vendas/equipevendas/listarusuarioequipevendadesvinculado?idEquipeVendas=${idEquipeVendas}`
        )
    );
}

//atualizar
export async function AtualizaUsuarioEquipeVendasService(
    requestBody: IUsuarioEquipeVendas
) {
    return Service(
        Axios.put(
            `/vendas/equipevendas/atualizausuarioequipevenda`,
            requestBody
        )
    );
}
